import { render } from "./HelpRequestItem.vue?vue&type=template&id=5bd9c38f&scoped=true"
import script from "./HelpRequestItem.vue?vue&type=script&lang=js"
export * from "./HelpRequestItem.vue?vue&type=script&lang=js"

import "./HelpRequestItem.vue?vue&type=style&index=0&id=5bd9c38f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd9c38f"]])

export default __exports__